<template>
  <div class="relative bg-gray-900 shadow-xl lg:overflow-hidden lg:rounded-2xl">
    <div v-if="image" class="absolute inset-0">
      <TLazyimg
        :src="image"
        classes="h-full w-full"
        classes-img="block w-full h-full object-cover"
        alt=""
      />

      <div class="absolute inset-0 bg-primary-900/40 mix-blend-multiply" />
    </div>
    <div class="relative px-6 py-16 lg:px-8 lg:py-32 text-center">
      <TTitle tag="h1" size="5xl" :bold="true" classes="mb-0">
        <span class="block text-white">{{ title }}</span>
        <span class="block text-primary-300">{{ name }}</span>
      </TTitle>
      <UButton
        v-if="link && buttonText"
        :ui="mobileFullWidthButton"
        color="neutral"
        variant="subtle"
        size="xl"
        :to="link"
        external
        :label="buttonText"
        class="mt-4"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

export interface propsInterface {
  image: string
  title: string
  name?: string
  buttonText?: string
  link?: string
}

defineProps<propsInterface>()
</script>
